<template>
  <section role="region" class="partner-logged-area">
    <div class="content-box">
      <div class="content-text">
        <TheSecondHead 
          chipText="Para você" 
          titleText="Aréa do cliente" 
          subtitleText="Acesse boletos, contratos e informações de acordos e produtos diretamente na área logada." 
        />
        <div class="white-box">
          <img :src="`/images/${imageFolder}/icon-check.png`" altText="Icone check" loading="lazy" />
          <p>Tudo o que você precisa em um só lugar</p>
        </div>
      </div>
      <div class="content-image">
        <ThePicture 
          :mobilePath="`/images/${imageFolder}/m-logged-area.png`"
          :desktopPath="`/images/${imageFolder}/logged-area.png`" 
          mobileQuerie="833px" 
          desktopQuerie="834px"
          :altText="`Area logada de ${imageFolder}`" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  imageFolder: string
}>();
</script>

<style lang="scss" scoped></style>